/**
 * European Sovereign Cloud (ESC) utility functions.
 * Shared across calculator components to avoid duplication.
 */

const ESC_CALCULATOR_DOMAIN = 'pricing.calculator.aws.eu';

/**
 * Check if a URL is from the ESC pricing calculator.
 * @param {string} url - Calculator URL to check
 * @returns {boolean}
 */
export const isESCCalculatorUrl = (url) =>
  typeof url === 'string' && url.includes(ESC_CALCULATOR_DOMAIN);

/**
 * Get the currency code for a calculator context.
 * @param {boolean} isESC - Whether this is an ESC calculator
 * @returns {string} 'EUR' or 'USD'
 */
export const getESCCurrency = (isESC) => isESC ? 'EUR' : 'USD';
